import { getNestedValue, tailwindClassForColoredButton } from "../../Helper/utils"
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function LineForTable({columns, element, index, buttons, selectable = false, selectedIds = [], onToggleSelect = () => {}}) {
    // Fonction pour vérifier si le bouton doit être affiché
    const shouldShowButton = (button) => {
        // Si la condition n'est pas définie, on affiche toujours le bouton
        if (button.condition === undefined || button.condition === null) {
            return true;
        }
        
        // Si la condition est une fonction, on l'évalue avec l'élément
        if (typeof button.condition === 'function') {
            return button.condition(element);
        }
        
        // Sinon, on retourne la valeur directe de la condition
        return button.condition;
    };

    return (
        <tr className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
            {selectable && (
                <td className="px-4 py-4">
                    <input
                        type="checkbox"
                        checked={selectedIds.includes(element.id)}
                        onChange={() => onToggleSelect(element.id)}
                        className="h-4 w-4"
                    />
                </td>
            )}
            {columns.map((column, colIndex) => {
                if (column.display === "Actions") {
                    return (
                        <td key={`${index}-${colIndex}`} className="px-4 py-4 break-words">
                            <div className="flex flex-row space-x-2">
                                {buttons.map((b, buttonIndex) => (
                                    shouldShowButton(b) && (
                                        <button
                                            key={`${index}-${colIndex}-${buttonIndex}`}
                                            className={tailwindClassForColoredButton(b.color)}
                                            onClick={() => b.action(getNestedValue(element, b))}
                                        >
                                            {
                                                b.display === "Éditer" ? (
                                                    <EditIcon />
                                                ) : b.display === "Supprimer" ? (
                                                    <DeleteIcon />
                                                ) : (
                                                    b.display
                                                )
                                            }
                                        </button>
                                    )
                                ))}
                            </div>
                        </td>
                    );
                }
                
                return (
                    <td key={`${index}-${colIndex}`} className="px-4 py-4 break-words">
                        <div className="max-w-xs lg:max-w-sm xl:max-w-md">
                            {getNestedValue(element, column)}
                        </div>
                    </td>
                );
            })}
        </tr>
    );
}